<template>
  <div class="content-box">
    <div class="element-wrapper">
      <div class="element-box">
        <h5 class="form-header">Mayor Contable</h5>
        <!-------------------- START - Controles arriba de tabla-------------------->
        <div class="controls-above-table">
          <div class="row">
            <div class="col-12 col-lg-6">
              <div class="row">
                <div class="col-6">
                  <label>Fecha inicio</label>
                  <input v-model="current.fecha_inicio" class="form-control" type="date" />
                </div>
                <div class="col-6">
                  <label>Fecha fin</label>
                  <input v-model="current.fecha_fin" class="form-control" type="date" />
                </div>

                <div class="col-12">
                  <div class="form-group">
                    <label>Centro de Costo</label>
                    <select class="form-control" autofocus="autofocus" v-model="current.centro_costo">
                      <option value="*">Todas</option>
                      <option v-for="(c, key) in centros_costos" :value="c.id" :key="key">
                        {{ c.id }} - {{ c.nombre }}
                      </option>
                    </select>
                  </div>
                </div>

                <div class="col-sm-12">
                  <div class="form-group">
                    <div class="form-check">
                      <label class="form-check-label">
                        <input checked="" class="form-check-input" name="optionsRadios" type="radio"
                          v-model="current.tipo_reporte" value="R">Resumido</label>
                    </div>
                    <div class="form-check">
                      <label class="form-check-label">
                        <input class="form-check-input" name="optionsRadios" type="radio" v-model="current.tipo_reporte"
                          value="D">Detallado</label>
                    </div>
                  </div>
                </div>

                <div class="col-sm-12">
                  <button :disabled="current.fecha_inicio == null ||
                    current.fecha_fin == null ||
                    current.centro_costo == null
                    " @click="GenerarReporte()" type="button" class="btn btn-success btn-block">
                    <i class="fas fa-download">

                    </i>
                    Generar Reporte
                  </button>
                </div>

              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import DynamicService from "@/services/commons/DynamicService";
import UsuariosService from "@/services/accounts/UsuariosService.js";

export default {
  components: {},
  data() {
    return {
      centros_costos: [],
      current: {
        centro_costo: "*",
        fecha_inicio: moment(new Date()).format("YYYY-MM-DD"),
        fecha_fin: moment(new Date()).format("YYYY-MM-DD"),
        usuario: null,
        tipo_reporte: "R",
      },
    };
  },
  mounted() {
    this.refreshCentroCosto();
    this.usuarioGet();
  },
  methods: {
    usuarioGet() {
      UsuariosService.profile().then((response) => {
        this.current.usuario = response.data.id;
      });
    },
    refreshCentroCosto() {
      let self = this;
      DynamicService.fetch("cat", "centro-costo", {
        quitar_paginacion: true,
      }).then((res) => {
        self.centros_costos = res.data;
      });
    },
    GenerarReporte() {
      let self = this;
      const baseApiUrl = process.env.VUE_APP_ROOT_API;
      const params = `&fecha_inicio=${self.current.fecha_inicio}&fecha_fin=${self.current.fecha_fin}&centro_costo=${self.current.centro_costo}&usuario=${self.current.usuario}&tipo_reporte=${self.current.tipo_reporte}`;
      const reporte = `/cat/reporte/?&report_format=pdf&report_name=conta/mayor_d.jrxml`;
      window.open(`${baseApiUrl}${reporte}${params}`);
      // self.current.fecha_fin = null;
      // self.current.fecha_inicio = null;
      // self.current.centro_costo = null;
    },
  },
};
</script>
